/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-11 15:11:04
 * @LastEditTime: 2022-01-11 16:01:56
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 银联对账单 - 汇总数据终端列表
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/YLPayOrderSummaryList/components/YlPayOrderSummaryDataList.jsx
 */
import React from 'react'
import TableHelper from '../../../../components/TableHelper';
import { fetchPlatformRecordYlPayOrderSummaryDataInfoPage } from '../../../../services/platformAccountingRecord';
import { formatTime } from '../../../../utils';

const YlPayOrderSummaryDataList = (props) => {

    const columns = [
        { title: '终端号', dataIndex: 'terminalNumber', },
        { title: '交易笔数', dataIndex: 'tradeNum', },
        { title: '交易金额', dataIndex: 'tradeAmount', },
        { title: '手续费', dataIndex: 'serviceCharge', },
        { title: '清算金额', dataIndex: 'liquidationAmount', },
        { title: '创建时间', dataIndex: 'createTime', render: (text) => formatTime(text)},

    ]
    const parseRequestData = (data) => {
        data.summaryDataId = props.id
        return data
    }
    return (
        props.id &&
        <TableHelper columns={columns} parseRequestData={parseRequestData} request={fetchPlatformRecordYlPayOrderSummaryDataInfoPage}  />
    )
}

export default YlPayOrderSummaryDataList


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/YLPayOrderSummaryList/components/YlPayOrderSummaryDataList.jsx